<template>
    <div class="form-group">
        <label v-text="getLabel"></label>
        <div class="flex">
            <label class="flex align-items-center mr5 btn-grey rounded px-2 py-1" v-for="(label, key, index) in options">
                <input class="mr5" type="radio" name="background_color" v-model="currentSelected" :value="key">
                {{ label }}
            </label>
        </div>
    </div>
</template>

<script>
import fieldInfo from '../mixins/fieldInfo';

export default {
    name: "BackgroundColor",
    mixins: [
        fieldInfo
    ],
    data() {
        return {
            currentSelected: 0,
            options: {
                "": 'Geen achtergrond kleur',
                "back-1": 'Blauw',
                "back-2": 'Grijs',
                "back-3": 'Groen',
            }
        }
    },
    watch: {
        currentSelected(newValue, oldValue) {
            this.currentValue = newValue === 0 ? null : newValue;
        }
    },
    mounted() {
        this.currentSelected = this.currentValue === '' ? 0 : this.currentValue;
    }
}
</script>
